const isSSR = typeof window === 'undefined';
const context = (!isSSR && window.__INITIAL_STATE__) || {};

/**
 * Dynamically injects the PerimeterX script into the page if enabled.
 *
 * @returns {boolean}  True if the script tag was inserted (or attempted), false if disabled.
 */
export function loadPerimeterX() {
    if (!context.enableThirdPart) {
        return false;
    }

    const appId = context.perimeterxAppId;
    const scriptUrl = context.isDevelopment ? `//client.px-cloud.net/${appId}/main.min.js` : `/${appId.replace('PX', '')}/init.js`;

    try {
        const firstScript = document.getElementsByTagName('script')[0];
        const script = document.createElement('script');
        script.async = true;
        script.src = scriptUrl;
        firstScript.parentNode.insertBefore(script, firstScript);
    } catch (e) {
        console.error('PerimeterX failed to load:', e);
    }

    return true;
}

/**
 * Dynamically injects the DebugBear RUM script into the page with sampling.
 * Fires only if `enableThirdPart` is true and the random sample check passes.
 */
export function loadDebugBear() {
    if (!context.enableThirdPart) {
        return false;
    }

    try {
        const samplingRate = 100; // percentage
        if (Math.random() * 100 <= samplingRate) {
            const globalName = 'dbbRum';
            window[globalName] = window[globalName] || [];
            window[globalName].push(['presampling', samplingRate]);

            // Capture errors and unhandled rejections
            ['error', 'unhandledrejection'].forEach((eventName) => {
                window.addEventListener(eventName, (evt) => {
                    window[globalName].push([eventName, evt]);
                });
            });

            const script = document.createElement('script');
            script.async = true;
            script.src = 'https://cdn.debugbear.com/HEu0mSPWKRmV.js';
            document.head.appendChild(script);
        }
    } catch (e) {
        console.error('An error occurred initializing DebugBear RUM:', e);
    }

    return true;
}

/**
 * Adds a custom tag or value to the DebugBear RUM queue.
 *
 * @param {string} tag    - The name of the tag or event.
 * @param {*} value       - The value or payload to associate with the tag.
 */
export function addDebugBearTag(tag, value) {
    window.dbbRum = window.dbbRum || [];
    window.dbbRum.push([tag, value]);
}
